import * as React from 'react';
import { useGetContractsQuery } from 'src/services/api';
import { BreadCrumbBase } from '../UI/BreadCrumbBase';
import { useNotificationBreadcrumbsStyles } from './useNotificationBreadcrumbsStyle';

export const ContractNotificationDetailsBreadcrumbs: React.FC<{
  contractId: string;
  contractTemplateId: string;
  responderName: string;
}> = ({ contractId, contractTemplateId, responderName }) => {
  const classes = useNotificationBreadcrumbsStyles();
  const { data: contracts } = useGetContractsQuery({
    contractTemplateId,
  });
  const contract = contracts?.find((c) => c.id === contractId);

  const items = [
    { label: 'Contracts', path: '/contracts' },
    {
      label: contract?.name || '',
      path: `/contracts/details?templateId=${contractTemplateId}&view=submissions_requests`,
    },
    {
      label: responderName,
      path: `/contracts/submission?contractId=${contractId}`,
    },
  ];

  return (
    <div className={classes.breadcrumbs}>
      <BreadCrumbBase items={items} />
    </div>
  );
};
